import resourceService from './resource_service';

const modelName = 'app';

const attributes = {
  name: '',
  totalVolume: '',
  location: '',
  code: '',
  rfid: '',
  targetVolume: '',
  updatedAt: '',
  deletedAt: '',
  parentId: '',
  replacing: '',
  expectedDailyUsage: '',
};

const readOnlyAttributes = ['targetVolume'];

const relationships = {
  site: {
    jsonApi: 'hasOne',
  },
  appSteps: {
    jsonApi: 'hasMany',
  },
  appPermissions: {
    jsonApi: 'hasMany',
  },
};

export default resourceService(modelName, attributes, relationships, readOnlyAttributes);
